import { Grid } from "@mui/material";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import useHandleCancelFormProperty from "../hooks/useHandleCancelFormProperty";
import { memo, useMemo } from "react";
import usePropertyHelpTypeLocations from "../hooks/helps/usePropertyHelpTypeLocations";

const PropertyFooterForm = () => {
  return <ActionButtons />;
};

export default memo(PropertyFooterForm);

const ActionButtons = memo(() => {
  const handleCancelForm = useHandleCancelFormProperty();

  const { isCreate } = usePropertyHelpTypeLocations();

  const buttonLabel = useMemo(() => {
    return isCreate ? "Crear" : "Actualizar";
  }, [isCreate]);

  return (
    <Grid container gap={1} p={2}>
      <Grid item flex={1} />
      <Grid item xs="auto">
        <MxButton2
          onClick={handleCancelForm}
          color="error"
          variant="contained"
          children="Cancelar"
          testId="cancel-button"
        />
      </Grid>
      <Grid item xs="auto">
        <MxButton2
          color="primary"
          variant="contained"
          children={buttonLabel}
          type="submit"
          id="property-submit-button"
          testId="submit-button"
        />
      </Grid>
    </Grid>
  );
});
